import axios from 'axios';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { BsCheck } from 'react-icons/bs';
import { IoCloudUpload } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const IMPWebsiteModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    let initialData = {
        Name: '',
        Link: '',
    }

    const [fileUploading1, setFileUploading1] = useState(false);
    const [examBodyData, setExamBodyData] = useState(initialData);
    const fileRef = useRef(null);

    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            console.log(item)
            if (item.Sn > 0) {
                setExamBodyData({ Link: item.Link, Name: item.Name, Sn: item.Sn })
            }
            setModalBox(true);

        }
    }));

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.Name.trim().length === 0) {
                toast.error("Please Enter file title")
                return;
            } else if (examBodyData.Link.trim().length === 0) {
                toast.error("Please upload file first")
                return;
            }
            const response = axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/createIMPWebsite' : `/updateIMPWebsite`}`, examBodyData);
            console.log(response)
            toast.success(response.data.message);
            props.setDownloadsLoading(!props.loadDownloads);

        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setDownloadsLoading(!props.loadDownloads);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }
 


    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Website Details" : "Add Website Details"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary">File Title<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" name="" id="inputAcademicYear" value={examBodyData.Name} onChange={(e) => setExamBodyData({ ...examBodyData, Name: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary">Website Link<span className="required">*</span></label>
                            <input autoFocus className='form-control' value={examBodyData.Link} type="text" name="" id="inputAcademicYear" onChange={(e) => setExamBodyData({ ...examBodyData, Link: e.target.value })} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Save"}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default IMPWebsiteModal;